import { Link, usePage } from "@inertiajs/react"

import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem, } from "@/components/ui/sidebar.tsx"
import { LightbulbIcon, UserRoundIcon } from "lucide-react";
import * as React from "react";

export function NavMain() {
    const {props, component} = usePage<PageProps>();
    const {organization} = props;

    return (
        <SidebarGroup>
            <SidebarMenu>
                <SidebarMenuItem>
                    <SidebarMenuButton asChild isActive={component.startsWith('App/Accounts')}>
                        <Link href={`/~/${organization.slug}/accounts`}>
                            <UserRoundIcon/>
                            <span>Client Accounts</span>
                        </Link>
                    </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                    <SidebarMenuButton asChild
                                       isActive={component.startsWith('App/Opportunities')}>
                        <Link href={`/~/${organization.slug}/opportunities`}>
                            <LightbulbIcon/>
                            <span>Opportunities</span>
                        </Link>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarGroup>
    )
}
